import { Offer } from '@wwt/entities/search-response'
import { showOfferConfigurationOfferStatuses } from '@wwt/shared/config'
import { extractFeaturesFromOffer, groupAllFeatures } from '@wwt/shared/utils'

export const useRoomSection = (offer: Offer | null) => {
	const roomFeatures = extractFeaturesFromOffer(offer, undefined, {
		room: true,
		hotel: false
	})

	const hotelFeatures = extractFeaturesFromOffer(offer, undefined, {
		room: false,
		hotel: true
	})

	const groupedRoomFeaturesMap = groupAllFeatures(roomFeatures)
	const groupedHotelFeaturesMap = groupAllFeatures(hotelFeatures)

	const isOfferConfigurationStatuses =
		offer?.IDs.status &&
		showOfferConfigurationOfferStatuses.includes(offer?.IDs.status)

	return {
		roomFeatureGroups: groupedRoomFeaturesMap,
		hotelFeatureGroups: groupedHotelFeaturesMap,
		roomName: offer?.roomDynamic.name,
		description: offer?.roomStatic.description,
		isOfferConfigurationDisabled: !isOfferConfigurationStatuses
	}
}
